// extracted by mini-css-extract-plugin
module.exports = {"toggler":"styles_toggler__1Xrr0"};